import env from '@polleverywhere/core/lib/env'
import { inIframe } from '../util/in_iframe'

/* global Rollbar */
/**
 * Update rollbar person data after session start
 */
export default (app) => {
  const environmentParts = [app.options.role]

  if (app.options.mode === 'integration') {
    environmentParts.push('integration')
  }

  environmentParts.push(env.get('rollbar_environment'))

  const dispatcher = _.clone(Backbone.Events)
  typeof Rollbar !== 'undefined' && Rollbar !== null && Rollbar.configure({
    transform: (payload) => {
      payload.state = app.state.inspect()

      // delete PII
      delete payload.state.user?.email
      delete payload.state.user?.first_name
      delete payload.state.user?.last_name
    },
    payload: {
      environment: environmentParts.join('-'),
      iframed: inIframe()
    },
    hostSafeList: [window.location.hostname, env.get('cdn_url')?.hostname()],
    reportLevel: 'error'
  })

  // this ensures it gets called each time the user logs out/in
  dispatcher.listenTo(app, 'reset:state', (state) => {
    // if an app allows anonymous usage like participant app we just associate it with the participant id
    dispatcher.listenTo(state, 'session:anonymous', () => {
      typeof Rollbar !== 'undefined' && Rollbar !== null && Rollbar.configure({
        payload: {
          person: {
            id: state.get('participant').id
          }
        }
      })
    })

    // When a session is authenticated include the user name in addition to the participant id
    dispatcher.listenTo(state, 'session:start', () => {
      typeof Rollbar !== 'undefined' && Rollbar !== null && Rollbar.configure({
        payload: {
          person: {
            id: state.get('participant').id,
            username: state.get('user').get('login')
          }
        }
      })
    })
  })
}
